//
//  Log 객체 생성 관리 (2018/06/01 정재윤)
// -
//
import Logger from './logger'

if (window.vue.getInstance('log') === undefined) {
  window.vue.setInstance('log', Logger)
}



// WEBPACK FOOTER //
// ./src/_fdp/core/logger/index.js